export default __webpack_public_path__ + "static/media/core-blockchain-twitter.ff2a9188.jpg";